@if (showShell()) {
  <app-topbar />
}
<main class="app-main">
  <router-outlet />
</main>
@if (showShell()) {
  <app-footer />
}
